import Localization from 'lib/localization';

export default {
  get lxEaaTitle() {
    return Localization.get('bumblesite@accessibility_eaa.title');
  },
  get lxEaaSectionOurPolicy() {
    return Localization.get('bumblesite@accessibility_eaa.our_policy');
  },
  get lxEaaSectionAccessibilityStatus() {
    return Localization.get('bumblesite@accessibility_eaa.accessibility_status');
  },
  get lxEaaSectionMeasuresTaken() {
    return Localization.get('bumblesite@accessibility_eaa.measures_taken');
  },
  get lxEaaSectionFutureImprovements() {
    return Localization.get('bumblesite@accessibility_eaa.future_improvements');
  },
  get lxEaaSectionFeedback() {
    return Localization.get('bumblesite@accessibility_eaa.feedback');
  },
  get lxEaaSectionLastUpdated() {
    return Localization.get('bumblesite@accessibility_eaa.last_updated');
  },
};
